import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

declare const __APP_BUILD_ID__: string;

const POLL_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck() {
  const hasNotified = useRef(false);

  useEffect(() => {
    if (import.meta.env.DEV) return;

    const checkVersion = async () => {
      if (hasNotified.current) return;
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { buildId } = await res.json();
        if (buildId && buildId !== __APP_BUILD_ID__) {
          hasNotified.current = true;
          toast('A new version is available', {
            duration: Infinity,
            action: {
              label: 'Refresh',
              onClick: () => window.location.reload(),
            },
          });
        }
      } catch {
        // silently ignore fetch errors
      }
    };

    const interval = setInterval(checkVersion, POLL_INTERVAL);
    
    const onVisibility = () => {
      if (document.visibilityState === 'visible') checkVersion();
    };
    document.addEventListener('visibilitychange', onVisibility);

    // Initial check after a short delay
    const timeout = setTimeout(checkVersion, 10_000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
}
